import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { WithdrawalScreen } from '../features/withdrawal/ui/withdrawal-screen';
import { getEmployeeProfile } from '../shared/api/employee.service';
import { useEmployeeSession } from '../shared/hooks/use-employee-session';
import {
  formatTaxIdInput,
  resolveEmployeeSessionCountryCode,
  resolveTaxIdFieldConfig,
} from '../shared/model';

export function WithdrawalPage() {
  const navigate = useNavigate();
  const { authContact, status } = useEmployeeSession();
  const profileQuery = useQuery({
    enabled: status === 'authenticated',
    queryFn: getEmployeeProfile,
    queryKey: ['employee', 'profile'],
  });
  const profile = profileQuery.data ?? null;
  const initialCountryCode = resolveEmployeeSessionCountryCode(
    profile,
    authContact,
  );
  const taxIdField = resolveTaxIdFieldConfig(initialCountryCode);
  const destinationTaxId = formatTaxIdInput(
    profile?.tin ?? '',
    initialCountryCode,
  );

  return (
    <WithdrawalScreen
      avatarUrl={profile?.avatarUrl ?? null}
      destinationTaxId={destinationTaxId}
      freeWithdrawalsCount={3}
      taxIdLabelKey={taxIdField.labelKey}
      onBack={() => {
        if (window.history.length > 1) {
          navigate(-1);
          return;
        }

        navigate('/home');
      }}
      onContinue={() => {
        navigate('/withdrawal/amount');
      }}
      onOpenHome={() => {
        navigate('/home');
      }}
      onOpenMyPage={() => {
        navigate('/my-page');
      }}
    />
  );
}
